import { FleetingLabelDuration } from '@/Support/Global/Interfaces/FleetingLabelDuration'

export const getFleetingTime = (
  duration: FleetingLabelDuration = FleetingLabelDuration.Normal,
) => duration * 1000
